import { render, staticRenderFns } from "./ConsultationChecklist.vue?vue&type=template&id=573f2732&lang=pug"
import script from "./ConsultationChecklist.vue?vue&type=script&lang=js"
export * from "./ConsultationChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports